export enum EInputIdentifier {
  ADDITIONAL_ADDRESS_LINE = `additional-address-line`,
  BIRTH_DATE = `birth-date`,
  CALL_TIMES = `call-times`,
  CITY = `city`,
  COUNTRY = `country`,
  CURRENCY = `currency`,
  EMAIL = `email`,
  FIRST_NAME = `first-name`,
  GENDER = `gender`,
  LANGUAGE = `language`,
  LAST_NAME = `last-name`,
  PASSWORD = `password`,
  PHONE_NUMBER = `tel`,
  PHONE_NUMBER_AREA_CODE = `tel-area-code`,
  PHONE_NUMBER_COUNTRY_CODE = `tel-country-code`,
  PHONE_NUMBER_LOCAL = `tel-local`,
  PHONE_NUMBER_TYPE = `tel-type`,
  POSTAL_CODE = `postal-code`,
  RECIPIENT = `recipient`,
  SALUTATION = `honorific-prefix`,
  SOCIAL_SECURITY_NUMBER = `social-security-number`,
  STREET = `street`,
  STREET_NUMBER = `street-number`,
  TAX_NUMBER = `tax-number`,
}
